import gql from 'graphql-tag';

const CartFragment = gql`
  fragment CartFragment on Cart {
    id
    checkoutUrl
    cost {
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              id
              title
              image {
                url
              }
              price {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`;

export const createCheckout = gql`
  mutation cartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      userErrors {
        message
        field
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${CartFragment}
`;

export const checkoutLineItemsAdd = gql`
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      userErrors {
        message
        field
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${CartFragment}
`;

export const checkoutLineItemsUpdate = gql`
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      userErrors {
        message
        field
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${CartFragment}
`;

export const checkoutLineItemsRemove = gql`
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      userErrors {
        message
        field
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${CartFragment}
`;

export const checkoutCustomerAssociate = gql`
  mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      userErrors {
        message
        field
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${CartFragment}
`;

export function addVariantToCart(variantId, quantity){
  this.props.checkoutLineItemsAdd(
    { variables: { cartId: this.state.checkout.id, lines: [{merchandiseId: variantId, quantity: parseInt(quantity, 10)}] }
    }).then((res) => {
    this.setState({
      checkout: res.data.cartLinesAdd.cart
    });
  });

  this.handleCartOpen();
}

export function updateLineItemInCart(lineItemId, quantity){
  this.props.checkoutLineItemsUpdate(
    { variables: { cartId: this.state.checkout.id, lines: [{id: lineItemId, quantity}] }
    }).then((res) => {
    this.setState({
      checkout: res.data.cartLinesUpdate.cart
    });
  });
}

export function removeLineItemInCart(lineItemId){
  this.props.checkoutLineItemsRemove(
    { variables: { cartId: this.state.checkout.id, lineIds: [lineItemId] }
    }).then((res) => {
    this.setState({
      checkout: res.data.cartLinesRemove.cart
    });
  });
}

export function associateCustomerCheckout(customerAccessToken){
  this.props.checkoutCustomerAssociate(
    { variables: { cartId: this.state.checkout.id, buyerIdentity: { customerAccessToken: customerAccessToken } }
    }).then((res) => {
    this.setState({
      checkout: res.data.cartBuyerIdentityUpdate.cart,
      isCustomerAuthOpen: false
    });
  });
}
